import { WidgetProps } from '@rjsf/core';
import VerticalAlignment from './VerticalAlignment';

const ItemVerticalAlign = (props: WidgetProps) => {
    const { schema, onChange } = props;

    const handleAlignmentChange = (e: any) => {
        if (e === 'top') {
            onChange('flex-start');
        } else if (e === 'center') {
            onChange('center');
        } else {
            onChange('flex-end');
        }
    };
    return (
        <div className="vertical-item-alignment">
            <VerticalAlignment {...props} schema={schema} onChange={handleAlignmentChange} />
        </div>
    );
};

export default ItemVerticalAlign;
